import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  UkIndustryEcommerceIcon,
  UkTaxiBookingIcon,
} from "../../../../app-constants";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import Modal from "react-bootstrap/Modal";
import PopUp from "../../components/popUp";

function Industryukapp() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <section className="industry_uk_app p-100">
        <Container>
          <Row>
            <Col
              xs={12}
              md={10}
              lg={9}
              xl={8}
              xxl={7}
              className="m-auto text-center"
            >
              <h2>
                Delivering <span>Web Excellence</span> Across Industries
              </h2>
              <p>
                As a premier web development company in the UK, we provide
                tailored solutions using the latest technologies. Our focus on
                industry-specific needs ensures the delivery of robust, scalable
                websites optimized for performance and user experience. We
                leverage advanced frameworks and best practices to drive
                measurable business results.
              </p>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
              <div className="industy_uk_main">
                <div className="industy_uk_item">
                  <div className="industry_uk_icon">
                    {UkIndustryEcommerceIcon}
                  </div>
                  <div className="industry_uk_content">
                    <h5>E-commerce</h5>
                  </div>
                </div>
                <div className="industy_uk_item">
                  <div className="industry_uk_icon">{UkTaxiBookingIcon}</div>
                  <div className="industry_uk_content">
                    <h5>Taxi Booking</h5>
                  </div>
                </div>
                <div className="industy_uk_item">
                  <div className="industry_uk_icon">
                    <StaticImage
                      src="../../../images/location_new/uk-mobile/industry_icons/tourism.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={90}
                      height={89}
                    />
                  </div>
                  <div className="industry_uk_content">
                    <h5>Tourism</h5>
                  </div>
                </div>
                <div className="industy_uk_item">
                  <div className="industry_uk_icon">
                    <StaticImage
                      src="../../../images/location_new/uk-mobile/industry_icons/healthcare.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={90}
                      height={89}
                    />
                  </div>
                  <div className="industry_uk_content">
                    <h5>Healthcare </h5>
                  </div>
                </div>
                <div className="industy_uk_item">
                  <div className="industry_uk_icon">
                    <StaticImage
                      src="../../../images/location_new/uk-mobile/industry_icons/retail.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={90}
                      height={89}
                    />
                  </div>
                  <div className="industry_uk_content">
                    <h5>Retail</h5>
                  </div>
                </div>
                <div className="industy_uk_item">
                  <div className="industry_uk_icon">
                    <StaticImage
                      src="../../../images/location_new/uk-mobile/industry_icons/real_estate.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={90}
                      height={89}
                    />
                  </div>
                  <div className="industry_uk_content">
                    <h5>Real Estate</h5>
                  </div>
                </div>
                <div className="industy_uk_item">
                  <div className="industry_uk_icon">
                    <StaticImage
                      src="../../../images/location_new/uk-mobile/industry_icons/metaverse.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={90}
                      height={89}
                    />
                  </div>
                  <div className="industry_uk_content">
                    <h5>Metaverse</h5>
                  </div>
                </div>
                <div className="industy_uk_item">
                  <div className="industry_uk_icon">
                    <StaticImage
                      src="../../../images/location_new/uk-mobile/industry_icons/oil.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={90}
                      height={89}
                    />
                  </div>
                  <div className="industry_uk_content">
                    <h5>Oil & Gas</h5>
                  </div>
                </div>
                <div className="industy_uk_item">
                  <div className="industry_uk_icon">
                    <StaticImage
                      src="../../../images/location_new/uk-mobile/industry_icons/banking.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={90}
                      height={89}
                    />
                  </div>
                  <div className="industry_uk_content">
                    <h5>Banking</h5>
                  </div>
                </div>
                <div className="industy_uk_item">
                  <div className="industry_uk_icon">
                    <StaticImage
                      src="../../../images/location_new/uk-mobile/industry_icons/manufacturing.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={90}
                      height={89}
                    />
                  </div>
                  <div className="industry_uk_content">
                    <h5>Manufacturing</h5>
                  </div>
                </div>
                <div className="industy_uk_item">
                  <div className="industry_uk_icon">
                    <StaticImage
                      src="../../../images/location_new/uk-mobile/industry_icons/Logistics.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={90}
                      height={89}
                    />
                  </div>
                  <div className="industry_uk_content">
                    <h5>logistics</h5>
                  </div>
                </div>
                <div className="industy_uk_item">
                  <div className="industry_uk_icon">
                    <StaticImage
                      src="../../../images/location_new/uk-mobile/industry_icons/finTech.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={90}
                      height={89}
                    />
                  </div>
                  <div className="industry_uk_content">
                    <h5>FinTech</h5>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col
              xs={12}
              md={6}
              lg={6}
              xl={6}
              xxl={6}
              className="m-auto text-center"
            >
              <button
                onClick={handleShow}
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Get Industry Specific Web Development
              </button>
            </Col>
          </Row>
        </Container>
      </section>
      <Modal
        show={show}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-popup"
      >
        <div className="modal_forms">
          <PopUp setShow={setShow} />
        </div>
      </Modal>
    </>
  );
}

export default Industryukapp;
